export function removeSpecialCharacters (text) {
  const normalized = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  return normalized.replace(/[^a-zA-Z0-9 ]/g, '')
}
